import { useMutation, useQueryClient } from '@tanstack/react-query';
import { channelsApi } from '../services';

/**
 * Hook to deactivate a channel
 *
 * @returns React Query mutation result
 *
 * @example
 * const deactivateChannel = useDeactivateChannel();
 * deactivateChannel.mutate(channelId);
 */
export const useDeactivateChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => channelsApi.deactivate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['channels'] });
    },
  });
};
